namespace Areas.MeetingMinutes.Edit {
    "use strict";

    let taskId: number;
    let sessionId: number;
    let profileAccountId: number;
    let runQuery: boolean = false;
    let newAccountId: number; //for copy to different project


    let currentProfile: any;
    let currentTask: any;
    let currentAttendee: any;

    const baseUrl = "/MeetingMinutes/MeetingMinutes";

    
    export function goToActions(projectInfoId: number, sharePointLink: string) {
        return (e: any) => {
            if (e.value == 1) {
                goToSharePoint(sharePointLink);
                clearSelectBoxSelection(e);
                return;
            }
            if (e.value == 2) {
                goToPIFPAF(projectInfoId);
                clearSelectBoxSelection(e);
                return;
            }
            if (e.value == 3) {
                goToReportMeetingMinutes(e);
                clearSelectBoxSelection(e);
                return;
            }
        }
    }

    function goToSharePoint(sharePointLink) {
        if (sharePointLink != null) {
            Areas.websiteSharePoint(sharePointLink);
        }
        return
    }

    function goToPIFPAF(projectInfoId) {
        let linkInfo = "https://projectinitiation.capnet.ucla.edu/Requests/View/Index/" + projectInfoId + "";
        window.open(linkInfo);
    }

    export function goToReportMeetingMinutes(e) {
        const grid = $("#SessionGrid").dxDataGrid("instance");
        const rows = grid.getSelectedRowsData();
        if (rows.length == 1) {
            clearSelectBoxSelection(e);
            var id = rows[0].meetingMinutesSessionId;
            const url = `/Reports/Report/GetReport820/${id}`;
            window.open(url);
        }
    }

    export function getSessionId() {
        return sessionId;
    }

    export function canExecuteQuery() {
        return runQuery;
    }

    export function onContentReadySessionGrid(e: any) {

        profileAccountId = e.component.option("accountId");

        //on multi grid pages that are master detail we can't keep selecting first row
        let selectedRows = e.component.getSelectedRowsData();

        if (selectedRows.length < 1) {
            e.component.selectRowsByIndexes([0], false);
        }

        //see if a row was selected
        selectedRows = e.component.getSelectedRowsData();

        if (selectedRows.length < 1) {

            //still no selected so grid must be empty, disable Attendees and task

            let attendeesGrid: any = $("#AttendeesGrid").dxDataGrid("instance");
            let taskGrid: any = $("#TaskGrid").dxDataGrid("instance");

            attendeesGrid.option("disabled", true);
            taskGrid.option("disabled", true);
        }

    }

    export function onContentReadyChildGrids(e: any) {

        //on multi grid pages that are master detail we can't keep selecting first row
        let selectedRows = e.component.getSelectedRowsData();

        if (selectedRows.length < 1) {
            e.component.selectRowsByIndexes([0], false);
        }


    }


    export function onNewSessionRow(e: any) {
        e.data.accountId = e.component.option("accountId");
        e.data.meetingMinutesProfileId = e.component.option("profileId");

    }


    export function onNewTaskRow(e: any) {
        e.data.accountId = e.component.option("accountId");
        e.data.meetingMinutesSessionId = sessionId;
        currentTask = e.data;

    }

    export function onNewAttendeeRow(e: any) {
        e.data.accountId = e.component.option("accountId");
        e.data.meetingMinutesSessionId = sessionId;
        currentAttendee = e.data;
    }

    export function onSessionGridSelectionChanged(e: any) {
        let selectedRows = e.component.getSelectedRowsData();
        let attendeesGrid: any = $("#AttendeesGrid").dxDataGrid("instance");
        let taskGrid: any = $("#TaskGrid").dxDataGrid("instance");

        if (selectedRows.length === 1) {
            runQuery = true;
            sessionId = selectedRows[0].meetingMinutesSessionId;

            const data: any = e.selectedRowsData[0];

            attendeesGrid.option("disabled", false);
            taskGrid.option("disabled", false);
            Areas.refreshGrid("AttendeesGrid");
            Areas.refreshGrid("TaskGrid");

        } else {

            attendeesGrid.option("disabled", true);
            taskGrid.option("disabled", true);
        }
    }



    export function returnToListFromTab() {
        var linkInfo = "/MeetingMinutes/List/Active";
        location.href = linkInfo;

    }


    export function addSessionGridButtons(e: any) {
        const grid: DevExpress.ui.dxDataGrid = e.component;

        let visibleButton = grid.option("IsEditable");

        addButtonToToolbar(e.toolbarOptions, {
            elementAttr: { id: "session" },
            text: "Copy Meeting",
            hint: "Copy",
            type: "default",
            icon: "add",
            visible: visibleButton,
            onClick: copyMeeting
        }, "before");

        addButtonToToolbar(e.toolbarOptions, {
            elementAttr: { id: "session" },
            text: "Copy Meeting to Different Project",
            hint: "Copy to different project",
            type: "default",
            icon: "add",
            visible: visibleButton,
            onClick: copyMeetingToDifferentProject
        }, "before");

    }


    export function copyMeeting() {
        const dataGrid = $("#SessionGrid").dxDataGrid("instance");
        const selectedRows = dataGrid.getSelectedRowsData();

        if (selectedRows.length) {
            const id = selectedRows[0].meetingMinutesSessionId;
            const url = `/MeetingMinutes/MeetingMinutes/CopyMeetingMinutesSession/${id}`;

            sendRequest(url, "", "POST", () => {
                dataGrid.refresh();
                dataGrid.selectRowsByIndexes([0]);
            });
        }

    }

    export function copyMeetingToDifferentProject() {
        const dataGrid = $("#SessionGrid").dxDataGrid("instance");
        const selectedRows = dataGrid.getSelectedRowsData();

        if (selectedRows.length) {
            sessionId = selectedRows[0].meetingMinutesSessionId;
        }

        selectAccountForCopyMeeting();



    }

    function copyMeetingToDifferentProjectFinal() {

        const dataGrid = $("#SessionGrid").dxDataGrid("instance");
        const profileId = dataGrid.option("profileId");

        if (newAccountId > 0) {
            const url = `/MeetingMinutes/MeetingMinutes/CopyMeetingMinutesSessionToDifferentProject/${profileId}/${sessionId}/${newAccountId}`;

            sendRequest(url, "", "POST", () => {
                dataGrid.refresh();
               
            });
        }
    }




    function selectAccountForCopyMeeting() {
        const accountDialog = new Areas.Dialogs.AccountDialog(dialogClosingCopyMeeting);
    }

    function dialogClosingCopyMeeting(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;
        newAccountId = data.accountId;
        copyMeetingToDifferentProjectFinal();
    }


    export function selectAccount() {
        const accountDialog = new Areas.Dialogs.AccountDialog(dialogClosing);
    }

    function dialogClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        const dataGrid = $("#MeetingMinutesProfileGrid").dxDataGrid("instance");

        var rowIndex = getRowIndex(dataGrid);
        updateGridRow(dataGrid, rowIndex, data);
    }

    function getRowIndex(dataGrid: DevExpress.ui.dxDataGrid): number {
        let rowIndex = 0;

        if (currentProfile === undefined || currentProfile === null) {
            return rowIndex;
        } else if (currentProfile.meetingMinutesProfileId) {
            rowIndex = dataGrid.getRowIndexByKey(currentProfile.meetingMinutesProfileId);
        }

        return rowIndex;
    }

    function updateGridRow(dataGrid: DevExpress.ui.dxDataGrid, rowIndex: number, data: any) {

        dataGrid.cellValue(rowIndex, "accountId", data.accountId);
        dataGrid.cellValue(rowIndex, "accountName", data.accountName);
        dataGrid.cellValue(rowIndex, "projectCCNumber, data.projectCCNumber");

        currentProfile.accountId = data.accountId;
        currentProfile.accountName = data.accountName;
        currentProfile.projectCCNumber = data.projectCCNumber;

        profileAccountId = data.accountId;  //in case account Id is changed from model

        dataGrid.repaintRows([rowIndex]);
    }

    export function onEditingStart(e: any) {
        currentProfile = e.data;
    }

    export function editAccountTemplate(cellElement, cellInfo) {
        let accountDisplayName = !cellInfo.data.accountName ? "Select..." : cellInfo.data.accountName;
        let htmlString = `<div class="dx-texteditor dx-lookup-empty dx-widget dx-textbox dx-dropdowneditor dx-lookup dx-lookup-popover-mode"><input type="hidden" value=""><div class="dx-lookup-field-wrapper"><div class="dx-lookup-field" tabindex="0" role="combobox" aria-expanded="false">${accountDisplayName}</div><div class="dx-lookup-arrow" id="account-popup-button"></div></div></div>`;
        let html = $.parseHTML(htmlString);

        cellElement.on("click", selectAccount);
        cellElement.append(html);
    }


    //attendee contact lookup
    export function editContactTemplate(cellElement, cellInfo) {
        let contactDisplayName = !cellInfo.data.contactName ? "Select..." : cellInfo.data.contactName;
        let htmlString = `<div class="dx-texteditor dx-lookup-empty dx-widget dx-textbox dx-dropdowneditor dx-lookup dx-lookup-popover-mode"><input type="hidden" value=""><div class="dx-lookup-field-wrapper"><div class="dx-lookup-field" tabindex="0" role="combobox" aria-expanded="false">${contactDisplayName}</div><div class="dx-lookup-arrow" id="contact-popup-button"></div></div></div>`;
        let html = $.parseHTML(htmlString);

        cellElement.on("click", selectContact);
        cellElement.append(html);
    }

    export function selectContact() {
        const contactDialog = new Areas.Dialogs.ContactDialog(dialogContactClosing);
    }

    function dialogContactClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        const dataGrid = $("#AttendeesGrid").dxDataGrid("instance");

        var rowIndex = getAttendeesRowIndex(dataGrid);
        updateContactGridRow(dataGrid, rowIndex, data);
    }

    function getAttendeesRowIndex(dataGrid: DevExpress.ui.dxDataGrid): number {
        let rowIndex = 0;

        if (currentAttendee === undefined || currentAttendee === null) {
            return rowIndex;
        } else if (currentAttendee.meetingMinutesAttendeeId) {
            rowIndex = dataGrid.getRowIndexByKey(currentAttendee.meetingMinutesAttendeeId);
        }

        return rowIndex;
    }

    function updateContactGridRow(dataGrid: DevExpress.ui.dxDataGrid, rowIndex: number, data: any) {

        dataGrid.cellValue(rowIndex, "contactId", data.contactId);
        dataGrid.cellValue(rowIndex, "contactName", data.displayName);

        currentAttendee.contactId = data.contactId;
        currentAttendee.contactName = data.displayName;

        dataGrid.repaintRows([rowIndex]);
    }

    export function onAttendeeEditingStart(e: any) {
        currentAttendee = e.data;
    }

    export function onTaskEditingStart(e: any) {
        currentTask = e.data;
    }

    //task popup support
    interface ITextEditorDictionary {
        [index: string]: DevExpress.ui.dxTextBox;
    }


    const textEditorDictionary = {} as ITextEditorDictionary;

    export function onTaskEditorPrepared(e: any) {
        const fieldNames: Array<string> = [
            "displayName"
        ];

        if (e.parentType === "dataRow" && fieldNames.indexOf(e.dataField) > -1) {
            const editor: DevExpress.ui.dxTextBox = e.editorElement.dxTextBox('instance');
            textEditorDictionary[e.dataField] = editor;
        }
    }

    export function onTaskEditPopupShowing(e: any) {
        const items = e.component.option("toolbarItems");

        const saveButtonIndex = 0;
        const cancelButtonIndex = 1;
        const saveButton = items[saveButtonIndex];
        const cancelButton = items[cancelButtonIndex];

        const grid: any = $("#TaskGrid").dxDataGrid("instance");

        cancelButton.options.elementAttr = { class: "cancel" };
        cancelButton.options.icon = "revert";
        cancelButton.options.onClick = (e) => {
            grid.cancelEditData();
            grid.setMode(Areas.GridMode.Normal);
        };

        saveButton.options.type = "success";
        saveButton.options.icon = "save";
        saveButton.options.onClick = (e) => {
            grid.saveEditData();
            grid.setMode(Areas.GridMode.Normal);
        }

        e.component.option("toolbarItems", items);
    }

    function setTextBoxValue(textBox: DevExpress.ui.dxTextBox, value: string) {
        textBox.option("value", value);
    }

    //task assignee lookup
    export function selectTaskContact() {
        const parameters = { accountId: profileAccountId };
        const accountTeamContactLookupDialog =
            new Areas.Dialogs.AccountTeam.AccountTeamContactLookupDialog(
                dialogAccountTeamDialogClosing, parameters);

    }

    function dialogAccountTeamDialogClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        const grid: any = $("#TaskGrid").dxDataGrid("instance");
        const rowIndex = getTaskRowIndex(grid);

        setTextBoxValue(textEditorDictionary["displayName"], data.displayName);
        grid.cellValue(rowIndex, "taskAssignedToContactId", data.contactId);



    }

    function getTaskRowIndex(dataGrid: DevExpress.ui.dxDataGrid): number {
        let rowIndex = 0;

        if (currentTask === undefined || currentTask === null) {
            return rowIndex;
        } else if (currentTask.meetingMinutesTaskId) {
            rowIndex = dataGrid.getRowIndexByKey(currentTask.meetingMinutesTaskId);
        }

        return rowIndex;
    }

    export function contactValueChanged(args, setValueMethod) {
        if (!args.value) {
            selectedAccountTeamContact = null;
        }

        setValueMethod(args.value);
    }

    let selectedAccountTeamContact: any;

    export function onContactSelectionChanged(e, dropDownBoxInstance) {
        const selected = e.selectedRowsData[0];
        selectedAccountTeamContact = selected;

        const key = e.selectedRowKeys[0];
        dropDownBoxInstance.option("value", key);
    }

    export function onCloseBtnClick(args, dropDownBoxInstance) {
        dropDownBoxInstance.close();
    }

    export function setRowData(rowData: any, value: any) {
        if (selectedAccountTeamContact) {
            rowData.contactId = selectedAccountTeamContact.contactId;
            rowData.company = selectedAccountTeamContact.companyName;
            rowData.contactName = selectedAccountTeamContact.displayName;
            rowData.initials = selectedAccountTeamContact.initials;
        } else {
            rowData.contactId = null
        }
    }


}